import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { CruisebiosService } from 'src/app/Services/cruisebios.service';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';
import * as moment from 'moment';
import { TripContextService } from 'src/app/Services/trip-context.service';

type bioInfo = {
  crwName: string;
  crewRole: string;
  crbBioText: string;
  crbBioImageLink: string;
  spcPhoneNumber: string;
  crlOBPortalPhoneDisp: boolean;
  expander: boolean;
};

@Component({
  selector: 'app-bio-expander',
  templateUrl: './bio-expander.component.html',
  styleUrls: ['./bio-expander.component.css'],
  providers: [CruisebiosService],
})
export class BioExpanderComponent implements OnInit {
  userdata?: UserData;
  evtcode: string | undefined;
  OBPortalSvcURL = '';
  imagepath = '';

  cruisebios: bioInfo[] | undefined;
  cruisebiodata: any;

  currentdate: string | undefined;
  CurrentTime: string | undefined;
  pagemask: boolean | undefined; 

  cruiseBeg: Date | undefined; 
  cruiseEnd: Date | undefined; 
  pckgBeg: Date | undefined; 

  constructor(
    private appConfigService: AppConfigService,
    private CruisebiosService: CruisebiosService,
    private tripContextService: TripContextService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.imagepath = this.appConfigService.imagepath;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.evtcode = cruiseContentEvtCodeFromSession(this.userdata);
    this.pagemask = this.tripContextService.resolve(this.userdata).pagemask;

    this.getCruiseBios();
  }

  getCruiseBios() {
    this.cruisebiodata = this.CruisebiosService.getCruiseBios(
      this.evtcode
    ).subscribe((cruisebiodata) => this.setCruiseBios(cruisebiodata));
  }

  setCruiseBios(resdata: any) {
    this.cruisebiodata = resdata;
    if (this.cruisebiodata.GetCruiseBios.Result.Status == 'A') {
      this.cruisebios = this.cruisebiodata.GetCruiseBios.CruiseBiosList;
    }
  }


}
